import React from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import tw from "twin.macro";
import styled from "styled-components";
import UpcomingInterview from "./cards/UpcomingInterview";
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "../misc/Headings.js";
import Navbarlogedin from "./Navbarlogedin";
import { TextField, Button, Grid, Typography, Box } from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./CompletedInterviews.css";
import Link from "@mui/material/Link";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";
import {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
} from "./days";
const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Issue = () => {
  const [show, setShow] = React.useState(false);
  const [date, setDate] = React.useState(new Date());
  const [hmopen, sethmOpen] = React.useState(false);
  const [checked, setChecked] = React.useState("");
  const handleChangeRadio = (event) => {
    setChecked(event.target.value);
  };
  const handleClickOpen = () => {
    sethmOpen(true);
  };

  const handleClickClose = () => {
    sethmOpen(false);
  };
  const [data, setData] = React.useState({
    textofArea: "",
  });
  const handleChangeofBox = (e) => {
    const value = e.target.value;
    setData({
      ...data,
      [e.target.name]: value,
    });
  };
  const display = (day) => {
    const date = day.toLocaleDateString();
    day = day.getDay();
    if (day === 0) {
      return <Sunday date={date} />;
    } else if (day === 1) {
      return <Monday date={date} />;
    } else if (day === 2) {
      return <Tuesday date={date} />;
    } else if (day === 3) {
      return <Wednesday date={date} />;
    } else if (day === 4) {
      return <Thursday date={date} />;
    } else if (day === 5) {
      return <Friday date={date} />;
    } else {
      return <Saturday date={date} />;
    }
  };
  const subheading = "",
    heading = (
      <>
        <span tw="text-changed-100">Cancel a Mock Interview</span>
        <wbr />
      </>
    ),
    description =
      "Please Enter the Mock Interview ID and then proceed to cancel your mock interview.",
    textOnLeft = true;
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const [cards, setCards] = React.useState(null);

  const [inputs, setInputs] = React.useState({
    idVerify: "",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs({ ...inputs, [name]: value });
  };
  async function fetchData() {
    console.log(inputs.idVerify);
    console.log("id");
     if(inputs.idVerify===""){
      window.alert("Please enter a valid Mock Interview ID")
       return
     }
    await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/get/${inputs.idVerify}`
    ).then((response) => {
      setCards(response.data)
    localStorage.setItem("details",JSON.stringify(response.data))
    //console.log(JSON.parse(localStorage.getItem("details")).toname)
    }).catch((error) => {
      window.alert("Please enter a valid Mock Interview ID")
      window.scrollTo(0, 0);
      console.error(error);
    })
    
  }

  return (
    <>
      <Helmet>
        <title>Interwiu | Cancel Interview</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <Container>
        <TwoColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              {subheading && <Subheading>{subheading}</Subheading>}
              <Heading>{heading}</Heading>
              {description && <Description>{description}</Description>}
            </TextContent>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <input
                  type="text"
                  name="idVerify"
                  className="border-2 rounded"
                  value={inputs.idVerify}
                  onChange={handleChange}
                  placeholder="Last Name"
                />
                <Button onClick={fetchData}>Verify</Button>
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <h5>Details of the Mock Interview </h5>
                {cards &&
                  <UpcomingInterview
                    name={JSON.parse(localStorage.getItem("details")).toname}
                  //  desg={result.desg}
                    profile={JSON.parse(localStorage.getItem("details")).profile}
                    price={JSON.parse(localStorage.getItem("details")).price}
                    slot={JSON.parse(localStorage.getItem("details")).slot}
                    status={JSON.parse(localStorage.getItem("details")).status}
                    payment={JSON.parse(localStorage.getItem("details")).payment}
                    id={JSON.parse(localStorage.getItem("details"))._id}
                    logo={require("../../images/amazon.png")}
                />
              }
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <FormControl
                sx={{ m: 3 }}
                component="fieldset"
                variant="standard"
              >
                <FormLabel component="legend">
                  Why do you want to cancel this mock interview?
                </FormLabel>
                <FormGroup>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value="one"
                      label="I got something else to do at that time"
                      onChange={handleChangeRadio}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="two"
                      label="I think I can perform well in my actual placement interview without having appeared in a mock interview"
                      onChange={handleChangeRadio}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="three"
                      label="I am not interested for this profile anymore "
                      onChange={handleChangeRadio}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="four"
                      label="I want to have my mock interviewer with another interviewer"
                      onChange={handleChangeRadio}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="five"
                      label="Other Issues"
                      onChange={handleChangeRadio}
                    />
                    <TextField
                      type="text"
                      name="textofArea"
                      label="Describe your issue(s) in detail"
                      multiline
                      rows={4}
                      sx={{ mt: 2 }}
                      value={data.textofArea}
                    onChange={handleChangeofBox}

                    />
                  </RadioGroup>
                </FormGroup>
              </FormControl>
            </Grid>

            <Grid item sx={{ mt: 2, mb: 2 }}>
              <Typography>
                If the current interview slot does not suit you well, you can
                better{" "}
                <Link
                  onClick={() => setShow((prev) => !prev)}
                  underline="hover"
                  sx={{ fontWeight: "bold", "&:hover": { cursor: "pointer" } }}
                >
                  {"Reschedule this Mock Interview"}
                </Link>{" "}
                rather than cancelling it
                {show && (
                  <Grid item sx={{ mt: 2, mb: 2 }}>
                    <Box>
                      <Typography
                        id="modal-modal-title"
                        variant="h5"
                        sx={{
                          fontWeight: "bold",
                          textAlign: "center",
                          mb: 2,
                        }}
                      >
                        Choose a New Slot for Mock Interview with Mr. John Doe
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid xs={6}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <CalendarPicker
                              date={date}
                              format="dd/MM/yyyy"
                              onChange={(newDate) => setDate(newDate)}
                              views={["day"]}
                              disablePast={true}
                            />
                          </LocalizationProvider>
                        </Grid>

                        <Grid
                          xs={6}
                          sx={{
                            mt: 2,
                          }}
                        >
                          {display(date)}
                        </Grid>
                        <Grid xs={12} sx={{ textAlign: "center" }}></Grid>
                      </Grid>
                    </Box>
                  </Grid>
                )}
              </Typography>

              <Button sx={{ mt: 2 }} onClick={() => {
                    console.log(checked)
                    if(checked===""){
                      window.alert("Please select Atleast one reason")
                      window.scrollTo(0, 0);
                      return
                    }
                      const obj = {
                        canceled: true,
                        cncellingTypeId:JSON.parse(localStorage.getItem("isAuthenticated"))._id,
                        cancelReasonAuto: checked,
                        cancelReasonManual:data.textofArea,
                        reporterType:JSON.parse(localStorage.getItem("isAuthenticated")).role,
                        reschedulePage:"cancel_page"
                        
                      };
                      axios
                        .patch(
                          `${process.env.REACT_APP_SERVER_URL}/api/edit/${inputs.idVerify}`,
                          obj
                        )
                        .then((response) => {
                          console.log(response.status);
                          console.log(response.data);
                      window.alert("Are you sure?");
                        }).catch((error)=>{
                          window.alert("Please enter a valid Mock Interview Id")
                          window.scrollTo(0, 0);
                        })
                    }}>
                Cancel it anyways
              </Button>
              <Dialog
                hmopen={hmopen}
                onClose={handleClickClose}
                aria-labelledby="alert--title"
                aria-describedby="alert-"
              >
                <DialogTitle id="mm">
                  {"Are you sure to cancel your mock interview"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert--description">
                    you will get a complete refund after this cancellation. Read
                    refund policy for more details
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                  >
                    Cancel the interview
                  </Button>
                  <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </TextColumn>
        </TwoColumn>
      </Container>
    </>
  );
};
export default Issue;
